import { computed } from 'vue'
import { useLocale } from '@pit-element-plus/hooks'
import type { FormBaseProps } from './form-base'

export default function useFormBaseLocale(props: FormBaseProps) {
  const { t } = useLocale()

  // 新建按钮文字
  const localeAddBtnText = computed(
    () => props.addBtnText || t('el.formBase.addBtnText')
  )

  // 编辑按钮文字
  const localeEditBtnText = computed(
    () => props.editBtnText || t('el.formBase.editBtnText')
  )

  // 删除按钮文字
  const localeDelBtnText = computed(
    () => props.delBtnText || t('el.formBase.delBtnText')
  )

  // 批量删除按钮文字
  const localeBatchBtnText = computed(
    () => props.batchBtnText || t('el.formBase.batchBtnText')
  )

  // 展开按钮文字
  const localeExpandBtnText = computed(() => t('el.formBase.expandBtnText'))

  // 折叠按钮文字
  const localeFoldBtnText = computed(() => t('el.formBase.foldBtnText'))

  // 查询按钮文字
  const localeSearchBtnText = computed(
    () => props.searchBtnText || t('el.formBase.searchBtnText')
  )

  // 清空按钮文字
  const localeClearBtnText = computed(
    () => props.clearBtnText || t('el.formBase.clearBtnText')
  )

  // 保存按钮
  const localeConfirmBtnText = computed(
    () => props.confirmBtnText || t('el.formBase.confirm')
  )

  // 新建成功！
  const localeTextAddSuccess = computed(
    () => props.textAddSuccess || t('el.formBase.textAddSuccess')
  )

  // 修改成功！
  const localeTextEditSuccess = computed(
    () => props.textEditSuccess || t('el.formBase.textEditSuccess')
  )

  // 删除成功！
  const localeTextDelSuccess = computed(
    () => props.textDelSuccess || t('el.formBase.textDelSuccess')
  )

  // 是否删除已选中数据？
  const localeTextDelStr = computed(
    () => props.textDelStr || t('el.formBase.textDelStr')
  )

  // 您没有选中任何数据项,请选中后再操作！
  const localeTextEmptyOption = computed(
    () => props.textEmptyOption || t('el.formBase.textEmptyOption')
  )

  // 请选择一条数据！
  const localeTextEmptyOptionOne = computed(
    () => props.textEmptyOptionOne || t('el.formBase.textEmptyOptionOne')
  )

  // 暂存
  const localeStorageBtnText = computed(
    () => props.storageBtnText || t('el.formBase.storageBtnText')
  )

  // 保存草稿
  const localeDraftBtnText = computed(
    () => props.draftBtnText || t('el.formBase.draftBtnText')
  )

  // 发起流程
  const localeInitiateProcessBtnText = computed(
    () =>
      props.initiateProcessBtnText || t('el.formBase.initiateProcessBtnText')
  )

  // 流程保存成功
  const localeTextDraftSuccess = computed(
    () => props.textDraftSuccess || t('el.formBase.textDraftSuccess')
  )

  // 流程保存成功
  const localeTextProcessSuccess = computed(
    () => props.textProcessSuccess || t('el.formBase.textProcessSuccess')
  )

  return {
    localeAddBtnText,
    localeEditBtnText,
    localeDelBtnText,
    localeBatchBtnText,
    localeExpandBtnText,
    localeFoldBtnText,
    localeSearchBtnText,
    localeClearBtnText,
    localeConfirmBtnText,
    localeTextAddSuccess,
    localeTextEditSuccess,
    localeTextDelSuccess,
    localeTextDelStr,
    localeTextEmptyOption,
    localeTextEmptyOptionOne,
    localeStorageBtnText,
    localeDraftBtnText,
    localeInitiateProcessBtnText,
    localeTextDraftSuccess,
    localeTextProcessSuccess,
  }
}
